import React, { useEffect, useState } from 'react'

// react meta tags
import { ReactTitle } from "react-meta-tags";

// react redux
import { connect } from "react-redux";

// themes
import Theme1 from './themes/ContentTheme1'

function Content(props) {
    // props
    const {
        globalAppTheme,

        match
    } = props

    // states
    const [currentRoute, setCurrentRoute] = useState({})


    useEffect(() => {
        // const URLS_LIST = [
        //     "about-us",
        //     "faqs",
        //     "terms-and-conditions"
        //     "shipping-policy",
        //     "privacy-policy",
        // ]

        // // checking if the url is valid url
        // const urlCheck = url => {
        //     let isMatched = false
        //     if (url) {
        //         URLS_LIST.forEach(item => {
        //             console.log("item ", item);
        //             if (url.replaceAll(" ", "") !== item) {
        //                 isMatched = false
        //                 return isMatched
        //             } else {
        //                 isMatched = true
        //                 return isMatched
        //             }
        //         })
        //     }

        //     return isMatched
        // }

        if (match?.params?.pageName) {
            const routeUrl = match.params.pageName
            let routeName = ""

            console.log("routeUrl ", routeUrl);

            if(routeUrl === "terms") {
                routeName = "Terms and conditions"
            } else if(routeUrl === "shipping-payment") {
                routeName = "Shipping & Payment Info"
            } else if(routeUrl === "returns") {
                routeName = "FAQ"
            } else {
                routeName = routeUrl.replaceAll("-", " ")
            }

            setCurrentRoute({
                routeUrl,
                routeName
            })

        }
    }, [match.params.pageName])

    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={`${currentRoute.routeName} | krave Decor`} />
            {
                globalAppTheme === 'theme1' ? (
                    <Theme1 currentRoute={currentRoute} />
                ) : null
            }
        </React.Fragment>
    )
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         func: param => dispatch(func(param)),
//     };
// };

export default connect(getDataFromStore, null)(Content);